import {
  Show,
  SimpleShowLayout,
  TextField,
  DateField,
  BooleanField,
} from "react-admin";
export const GroupRoleShow = props => (
  <Show title="Group Role Details" {...props}>
    <SimpleShowLayout>
      <TextField source="id" label="Group ID" />
      <TextField source="group_name" label="Group" />
      <TextField source="roles" label="Roles" />
    </SimpleShowLayout>
  </Show>
);
